import React, { forwardRef, InputHTMLAttributes } from "react";

interface TextProps extends InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Text = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ name, type, value, onChange, ...rest }, ref) => {
  return (
    <input
      ref={ref}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      className="block pl-7 pr-12 py-4 rounded-full w-full placeholder:text-font-400 text-novartis-font font-semibold outline-none shadow-leap focus:ring-2 focus:ring-survey-brand"
      {...rest}
    />
  );
});

export default Text;
